<template>
  <div
    class="height100vh flex flex-col"
    id="pageBOX"
    @click="
      navList[1].isShowDropDown = false;
      shouUserMore = false;
    "
  >
    <div class="line"></div>
    <!--<div
      class="header-box"
      :style="`background : url(${backgroundImg});background-repeat: no-repeat;
    background-size: 100% 100%;`"
     v-if="$store.state.region === 1"
    ></div>-->
    <div
      class="header-box"
      :style="`background : url(${backgroundImglf});background-repeat: no-repeat;
    background-size: 100% 100%;`"
      v-if="$store.state.region === 2"
    ></div>
    <div
      class="header-box"
      :style="`background : url(${backgroundImgcz});background-repeat: no-repeat;
    background-size: 100% 100%;`"
      v-if="$store.state.region === 3"
    ></div>
    <!--v-if="$store.state.region === 5"-->
    <div
      class="header-box"
      :style="`background : url(${backgroundImgsx});background-repeat: no-repeat;
    background-size: 100% 100%;`"
    ></div>
    <!--<div
      class="header-box"
      :style="`background : url(${backgroundImgsx});background-repeat: no-repeat;
    background-size: 100% 100%;`"
      v-else
    ></div>-->
    <div class="bg-red">
      <div class="flex nav-box">
        <div class="flex-1">
          <navbar
            :navList="navList"
            @jumpPage="jumpPage"
            @isShowDropDown="navList[1].isShowDropDown = true"
          ></navbar>
        </div>
        <div
          class="flex align-items-center user-box"
          @click.stop
          @click="shouUserMore = !shouUserMore"
        >
          <a-avatar
            style="width: 30px; height: 30px; margin-right: 15px"
            icon="user"
          />
          <div class="flex align-items-center">
            <div
              style="max-width: 120px; min-width: 50px"
              class="nowrap"
              :title="$store.state.user.realname"
            >
              {{ $store.state.user.realname }}
            </div>
            <img class="img-small" src="../../assets/images/img41.png" alt="" />
          </div>
          <div class="user-more" @click.stop v-if="shouUserMore">
            <div
              class="user-more-item"
              @click="
                shouChangepw = true;
                shouUserMore = false;
              "
            >
              修改密码
            </div>
            <div style="border-top: 1px solid #ccc"></div>
            <div class="user-more-item" @click="logout">退出登录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-box flex-1">
      <!--:style="`background : url(${backgroundContentImg});background-repeat: no-repeat;
    background-size: 100% 100%;`"-->
      <div class="bg-box-back"></div>
      <div class="content-box flex flex-col">
        <div class="breadcrumb-box" v-if="!hideOuterBreadcrumb">
          <!--面包屑导航-->
          <a-breadcrumb separator=">">
            <a-breadcrumb-item
              v-for="breadcrumbItem in breadcrumbList"
              :href="breadcrumbItem.path"
              :key="breadcrumbItem.path"
              @click.native="go(breadcrumbItem)"
              >{{ breadcrumbItem.meta.title }}</a-breadcrumb-item
            >
          </a-breadcrumb>
        </div>
        <div class="container">
          <!--<a-affix
            :offset-top="300"
            :style="{ position: 'absolute', right: 0 }"
          >
            <div class="a-tip flex flex-col flex-between">
              <div @click="$router.push('/personalCenter/guide')">申报指南</div>
              <div @click="$router.push('/personalCenter/downLoad')">
                文件下载
              </div>
            </div>
          </a-affix>-->
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div v-if="$store.state.region != 5">
      <foot :FootType="2"></foot>
    </div>
    <div v-if="shouChangepw">
      <a-modal v-model="shouChangepw" title="修改密码">
        <p style="margin-top: 15px">原密码</p>
        <a-input
          type="password"
          placeholder="请输入原密码"
          v-model="passwordEdit.oldpassword"
        />
        <p style="margin-top: 15px">新密码</p>
        <a-input
          placeholder="请输入新密码"
          type="password"
          v-model="passwordEdit.password"
        />
        <p style="margin-top: 15px">确认密码</p>
        <a-input
          type="password"
          placeholder="请输入确认密码"
          v-model="passwordEdit.confirmpassword"
        />
        <template slot="footer">
          <a-button
            @click="
              shouChangepw = false;
              passwordEdit.oldpassword = '';
              passwordEdit.password = '';
              passwordEdit.confirmpassword = '';
            "
            >取消</a-button
          >
          <a-button
            style="background: #2155b5; color: #fff"
            @click="handleOkChangepw"
            >确认</a-button
          >
        </template>
      </a-modal>
    </div>
    <div
      class="msg-box"
      v-if="
        $store.state.role != 'education-guide-role' &&
        ($route.name == 'szStudio' ||
          $route.name == 'educationalBrand' ||
          $route.name == 'szMicroClass')
      "
    >
      <a-badge :count="messageCount" @click="showMsg">
        <img src="@/assets/images/msg.png" alt="" />
      </a-badge>
    </div>
    <MsgList ref="msgList" @fetchMessagesCount="fetchMessagesCount" />
  </div>
</template>

<script>
import { LogOut, updatePassword, getAction } from "../../api/index";
import navbar from "../../components/navbar";
import foot from "../../components/footer";
import MsgList from "../message/index.vue";
export default {
  name: "",
  components: {
    navbar,
    foot,
    MsgList,
  },
  props: {},
  data() {
    return {
      passwordEdit: {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
      },
      backgroundImg: require("../../assets/images/img20.png"),
      backgroundImglf: require("../../assets/images/img61.png"),
      backgroundImgcz: require("../../assets/images/img63.png"),
      backgroundImgsx: require("../../assets/images/imgsx1.jpg"),
      backgroundContentImg: require("../../assets/images/img35.png"),
      navList: [
        { name: "首页", routeName: "Homes" },

        {
          name: "思政教育工作室",
          routeName: "szStudio",
        },
        {
          name: "特色文化育人品牌",
          routeName: "educationalBrand",
        },
        {
          name: "思政微课",
          routeName: "szMicroClass",
        },
        {
          name: "工作通知",
          routeName: "Notice",
        },
        // {
        //   name: "数据分析",
        //   routeName: "schoolAnalyse",
        // },
        // {
        //   name: "工作通知",
        //   routeName: "Notice",
        // },
      ],
      navList1: [
        { name: "首页", routeName: "Homes" },

        {
          name: "思政教育工作室",
          routeName: "szStudio",
        },
        {
          name: "特色文化育人品牌",
          routeName: "educationalBrand",
        },
        {
          name: "思政微课",
          routeName: "szMicroClass",
        },
        {
          name: "数据分析",
          routeName: "schoolAnalyse",
        },
        {
          name: "工作通知",
          routeName: "Notice",
        },
        // {
        //   name: "工作通知",
        //   routeName: "Notice",
        // },
      ],
      navList2: [
        { name: "首页", routeName: "Homes" },

        {
          name: "思政教育工作室",
          routeName: "szStudio",
        },
        {
          name: "特色文化育人品牌",
          routeName: "educationalBrand",
        },
        {
          name: "思政微课",
          routeName: "szMicroClass",
        },
        {
          name: "数据分析",
          routeName: "Index",
        },
        {
          name: "工作通知",
          routeName: "Notice",
        },
        {
          name: "成果分析",
          routeName: "resultsAnalysis",
        },
        // {
        //   name: "通知公告",
        //   routeName: "Notice",
        // },
      ],
      shouUserMore: false,
      shouChangepw: false,
      messageCount: 0,
      // 1 学校发起审核人收到的审核消息 2 审核通过后 学校收到的审核详情消息 3 评分人收到的审核通过信息添加的消息 4 最高审核人收到的审核通过信息添加的消息
      roleMap: {
        "school-role": 2,
        "teacher-role": 2,
        "audit-role": 1,
        "score-role": 3,
        "education-role": 4,
      },
    };
  },
  computed: {
    breadcrumbList() {
      return this.$route.matched;
    },
    /** 项目详情页自带面包屑 +「项目总览」，隐藏外层避免重复 */
    hideOuterBreadcrumb() {
      return /ProjectDetail$/i.test(this.$route.name || "");
    },
  },
  watch: {},
  created() {},
  mounted() {
    if (this.$store.state.role === "education-role") {
      let jyjitem = {
        name: "系统设置",
        dropDownList: [
          {
            title: "用户管理",
            routeName: "systemSettingsUserManagement",
          },
          //        {
          //          title: "申报设置",
          //          routeName: "systemSettingsSetUp",
          //        },
          //        {
          //          title: "评审设置",
          //          routeName: "systemSettingsReviewSetUp",
          //        },
          // {
          //   title: "结果公布",
          //   routeName: "systemSettingsResult",
          // },
        ],
        isShowDropDown: false,
        routeName: "systemSettings",
        type: "dropDown",
      };
      this.navList.splice(1, 0, jyjitem);
      this.fetchMessagesCount();
    }
    if (this.$store.state.role === "education-guide-role") {
      // let jyjitem = {
      //   name: "系统设置",
      //   dropDownList: [
      //     {
      //       title: "用户管理",
      //       routeName: "systemSettingsUserManagement",
      //     },
      //   ],
      //   isShowDropDown: false,
      //   routeName: "systemSettings",
      //   type: "dropDown",
      // };
      // this.navList2.splice(1, 0, jyjitem);
      this.navList = this.navList2;
      // this.fetchMessagesCount();
    }
    if (this.$store.state.role === "school-role") {
       let jyjitem = {
        name: "系统设置",
        dropDownList: [
          {
            title: "用户管理",
            routeName: "systemSettingsUserManagement",
          },
          //        {
          //          title: "申报设置",
          //          routeName: "systemSettingsSetUp",
          //        },
          //        {
          //          title: "评审设置",
          //          routeName: "systemSettingsReviewSetUp",
          //        },
          // {
          //   title: "结果公布",
          //   routeName: "systemSettingsResult",
          // },
        ],
        isShowDropDown: false,
        routeName: "systemSettings",
        type: "dropDown",
      };
      this.navList1.splice(1, 0, jyjitem);
      this.navList = this.navList1;
    }
    if (this.$store.state.role != "education-guide-role") {
      this.fetchMessagesCount();
    }
  },
  methods: {
    jumpPage(item) {
      if (item.routeName == "schoolAnalyse") {
        this.$router.push({
          path: "/home/schoolAnalyse",
          query: {
            name: this.$store.state.user.realname,
            schoolid: this.$store.state.user.id,
          },
        });
      } else {
        this.$router.push({
          name: item.routeName,
        });
      }
    },
    handleOkChangepw() {
      this.passwordEdit.username = this.$store.state.user.username;
      updatePassword(this.passwordEdit).then((res) => {
        if (res.code === 200) {
          this.shouChangepw = false;
          this.passwordEdit.oldpassword = "";
          this.passwordEdit.password = "";
          this.passwordEdit.confirmpassword = "";
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    logout() {
      LogOut().then((res) => {
        if (res.code === 200) {
          window.sessionStorage.clear();
          this.$store.state.token = null;
          this.$router.push("/login");
        }
      });
    },
    go(path) {
      if (path.meta.title == "首页") {
        this.$router.push({
          name: "Homes",
        });
      }
    },
    async fetchMessagesCount() {
      try {
        const params = {
          izView: 0,
          type: this.roleMap[this.$store.state.role],
        };
        const res = await getAction("/audit/lxAuditMessage/getCount", params);
        if (res?.code == 200) {
          this.messageCount = res.result || 0;
        }
      } catch (error) {
        console.error("获取消息数失败:", error);
        this.$message.error("获取消息数失败");
      }
    },
    showMsg() {
      this.$refs.msgList.init();
    },
  },
};
</script>

<style scoped lang="scss">
.msg-box {
  position: fixed;
  bottom: 95px;
  right: 14%;
  width: 45px;
  height: 45px;
  img {
    width: 100%;
  }
}
@media (max-width: 1441px) {
  .msg-box {
    position: fixed;
    bottom: 65px;
    right: 2%;
    width: 45px;
    height: 45px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.line {
  height: 0.5px;
}
.header-box {
  width: auto;
  height: 168px;
  position: relative;
  top: -2px;
}
@media screen and (max-width: 1440px) {
  .header-box {
    width: auto;
    height: 128px;
    position: relative;
    top: -2px;
  }
}
.breadcrumb-box {
  margin-top: 10px;
  padding-left: 25px;
}
.user-more {
  position: absolute;
  width: 100%;
  min-width: 120px;
  top: 46px;
  padding: 0 30px;
  left: 0;
  z-index: 99;
  background: #fff;
  border: 1px solid #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.18);
}
.user-more-item:hover {
  color: #2155b5;
}
.user-box {
  position: relative;
  cursor: pointer;
}
.user-more-item {
  margin: 12px 0;
  text-align: center;
  color: #000;
}
.bg-box {
  position: relative;
  background: #f2f2f2;
}
.bg-box-back {
  // background: url(~@/assets/images/img35.png) no-repeat;
  // background-size: 100% 100%;
  position: absolute;
  height: 50%;
  width: 100%;
  bottom: 0;
}
.content-box {
  // width: 1200px;
  width: 1250px;
  height: 100%;
  position: relative;
  margin: 0 auto;
}
.container {
  margin: 10px 0 30px 0;
  height: 100%;
  position: relative;
  background: #fff;
  border-radius: 8px;
  color: #000;
  min-height: 450px;
  overflow: hidden;
  .a-tip {
    height: 233px;
    width: 30px;
    position: absolute;
    margin: 0;
    z-index: 1;
    > div {
      height: 110px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      cursor: pointer;
      padding: 10px 0;
      padding-left: 7px;
    }
    :first-child {
      background: #2155b5;
      color: #fff;
    }
    :last-child {
      background: #fcc485;
      color: #b25d24;
    }
  }
}
.nav-box {
  width: 1250px;
  margin: 0 auto;
  background: #2155b5;
  height: 46px;
}
.bg-red {
  position: relative;
  top: -4px;
  /* relative + top 上移后仍占原高度，用负 margin 吃掉底部空隙 */
  margin-bottom: -4px;
  background: #2155b5;
}
.img-small {
  width: 10px;
  height: 10px;
  margin-left: 8px;
  margin-right: 12px;
}
</style>
